import styled from 'styled-components';
import { PAGE_CONTAINER, BORDER_BOX_SIZING } from '../../../../../common/styles/Layout';
import { ThemeColours } from '../../../../styles/ThemeColours';
import { FontWeight, Orientation } from '../../../../styles/constants';
import { onMobile } from '../../../../styles/onMobile';
import { SpecialtyPill } from './SpecialtyPill/SpecialtyPill';

export const Container = styled.div`
  ${PAGE_CONTAINER}
  ${BORDER_BOX_SIZING}
  display: flex;
  flex-flow: column nowrap;
  padding-bottom: 0;

  ${onMobile} {
    margin: 0;
    padding-bottom: 84px;
  }

  ${Orientation.LANDSCAPE} {
    padding-bottom: 0;
  }
`;

export const Title = styled.p`
  color: ${ThemeColours.black};
  font-weight: ${FontWeight.SEMI_BOLD};
  margin: 0;
`;

export const PillContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 40px;

  ${onMobile} {
    flex-flow: column nowrap;
    margin-bottom: 16px;
  }
`;

export const StyledSpecialtyPill = styled(SpecialtyPill)`
  flex: 0 1 calc(20% - 16px);
  margin: 24px 16px 0 0;
  min-width: 214px;

  ${onMobile} {
    flex: 0 0 auto;
    margin: 16px 0 0;
  }
`;
